import { z } from 'zod'

const int32Schema = z.number().int().nonnegative().max(2147483647)

export const paginationSchema = z.object({
  nextCursor: z.string().optional(),
  hasMore: z.boolean().optional(),
  count: int32Schema.optional(),
})

export type Pagination = z.infer<typeof paginationSchema>
